var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"size-modal-btn",on:{"click":_vm.toggleProductSizeSidebar}},[_c('button',[_c('size-icon'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Show size-table')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }